import {
  FaGamepad,
  FaRocket,
  FaUserMd,
  FaCut,
  FaShoppingCart,
  FaTools,
  FaTruck,
  FaCar,
  FaMask,
  FaChalkboardTeacher,
  FaPlane,
  FaFilm,
  FaBook,
  FaCloudSun,
  FaGift,
  FaPhone,
  FaUserSecret,
  FaEnvelope,
  FaChurch,
  FaUtensils,
  FaBed,
} from "react-icons/fa";

export const GAMES = [
  {
    name: "Airline",
    path: "/games/airline",
    icon: FaPlane,
    color: "#4299E1",
    description: "Manage flights and help passengers!",
    isFree: false,
  },
  {
    name: "Astronaut",
    path: "/games/astronaut",
    icon: FaRocket,
    color: "#6C5CE7",
    description: "Explore the amazing space!",
    isFree: true,
  },
  {
    name: "Beauty Shop",
    path: "/games/beautyshop",
    icon: FaCut,
    color: "#FF8B94",
    description: "Create beautiful styles!",
    isFree: false,
  },
  {
    name: "Catholic Mass",
    path: "/games/catholicmass",
    icon: FaChurch,
    color: "#8B4513",
    description: "Learn about and participate in Catholic liturgy!",
    isFree: false,
    hidden: true,
  },
  {
    name: "Chef",
    path: "/games/chef",
    icon: FaUtensils,
    color: "#FF9A8B",
    description: "Become a master chef and cook delicious meals!",
    isFree: false,
  },
  {
    name: "Classroom",
    path: "/games/classroom",
    icon: FaChalkboardTeacher,
    color: "#4682B4",
    description: "Experience a day in the virtual classroom!",
    isFree: false,
  },
  {
    name: "Delivery Driver",
    path: "/games/delivery",
    icon: FaTruck,
    color: "#4ECDC4",
    description: "Deliver happiness!",
    isFree: false,
  },
  {
    name: "Dial-Up Connection",
    path: "/games/dialup",
    icon: FaPhone,
    color: "#9B59B6",
    description: "Experience the nostalgia of 90s internet connection!",
    isFree: false,
    type: "experience",
    hidden: true,
  },
  {
    name: "Doctor",
    path: "/games/doctor",
    icon: FaUserMd,
    color: "#A8E6CF",
    description: "Make everyone healthy and happy!",
    isFree: false,
  },
  {
    name: "Game Developer",
    path: "/games/gamedev",
    icon: FaGamepad,
    color: "#A8E6CF",
    description: "Make your own games!",
    isFree: false,
  },
  {
    name: "Greeting Card Store",
    path: "/games/greetingcardstore",
    icon: FaEnvelope,
    color: "#DAA520",
    description: "Create heartfelt cards for every occasion!",
    isFree: false,
  },
  {
    name: "Grocery Store",
    path: "/games/grocerystore",
    icon: FaShoppingCart,
    color: "#98DDCA",
    description: "Stock up on yummy food!",
    isFree: false,
  },
  {
    name: "Handyman",
    path: "/games/handyman",
    icon: FaTools,
    color: "#FFD93D",
    description: "Fix it and make it better!",
    isFree: false,
  },
  {
    name: "Hotel",
    path: "/games/hotel",
    icon: FaBed,
    color: "#FF6B6B",
    description: "Run your own magical hotel!",
    isFree: true,
  },
  {
    name: "Library",
    path: "/games/library",
    icon: FaBook,
    color: "#805AD5",
    description: "Help readers find their next adventure!",
    isFree: false,
  },
  {
    name: "Movie Theater",
    path: "/games/movietheater",
    icon: FaFilm,
    color: "#E53E3E",
    description: "Sell tickets and serve up movie snacks!",
    isFree: false,
  },
  {
    name: "Restaurant",
    path: "/games/restaurant",
    icon: FaUtensils,
    color: "#4ECDC4",
    description: "Run your own restaurant and serve customers!",
    isFree: true,
  },
  {
    name: "Secret Agency",
    path: "/games/secretagency",
    icon: FaUserSecret,
    color: "#2C3E50",
    description: "Complete top secret missions and analyze classified intel!",
    isFree: false,
  },
  {
    name: "Ride Share Driver",
    path: "/games/rideshare",
    icon: FaCar,
    color: "#FFD93D",
    description: "Drive people around town!",
    isFree: false,
  },
  {
    name: "Super Hero",
    path: "/games/superhero",
    icon: FaMask,
    color: "#6C63FF",
    description: "Save the day, hero!",
    isFree: false,
  },
  {
    name: "Weather Reporter",
    path: "/games/weather",
    icon: FaCloudSun,
    color: "#4299E1",
    description: "Predict the weather and help people plan their day!",
    isFree: false,
  },
  {
    name: "Nice List",
    path: "/games/nicelist",
    icon: FaGift,
    color: "#dc3545",
    description: "Help Santa choose perfect gifts for good children!",
    showInDecemberOnly: true,
    isFree: false,
  },
].sort((a, b) => a.name.localeCompare(b.name));
